import { render, staticRenderFns } from "./LmInbox.vue?vue&type=template&id=acd8a2b2&scoped=true&"
import script from "./LmInbox.vue?vue&type=script&lang=js&"
export * from "./LmInbox.vue?vue&type=script&lang=js&"
import style0 from "./LmInbox.vue?vue&type=style&index=0&id=acd8a2b2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd8a2b2",
  null
  
)

export default component.exports